import * as React from 'react';
import { Checkbox } from 'antd';
import { BodyGroup } from '@component/index';
import { ENTITY_RECOGNIZER } from '@config/index';
import { localizedString } from '@locale/index';

import '@style/recognizer/index.less';

const CheckboxGroup = Checkbox.Group;

export const RecognizerComp = ({
  data,
  onChange,
  disabled
}: {
  data: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}) => {

  return (
    <BodyGroup
      className="recognizer-group"
      title={localizedString('entity_recognizer')}
      titleExtra={
        <CheckboxGroup
          disabled={disabled}
          style={{ marginLeft: 16 }}
          options={[{
            label: localizedString('entity_recognizer_list'),
            value: ENTITY_RECOGNIZER.LIST
          }, {
            label: localizedString('entity_recognizer_duckling'),
            value: ENTITY_RECOGNIZER.DUCKLING
          }]}
          value={data}
          onChange={(value: any) => {
            onChange(value);
          }}
        />
      }
      extra={[]}
    />
  );
};
